const plans = {
  features: {
    NO_WATERMARK: 'Unbranded',
    'A/B_TESTING': 'A/B Testing',
    DETAILED_ANALYTICS: 'Detailed Analytics',
    MULTI_STEP: 'Multi-step campaigns',
    // INTEGRATIONS: 'Integrations',
    INFINITE_CAMPAIGNS: 'Infinite Campaigns',
    // TEN_K_VISITORS: '10k Visitors/mo',
    // ANALYTICS: 'Analytics',
    // AUDIENCE_DATE: 'Audience Date',
    // CUSTOM_FONTS: 'Custom Fonts',
    // PREMIUM_TEMPLATES: 'Premium templates',
    // WHITE_LABELLING: 'White Labelling',
    PRIORITY_SUPPORT: 'Priority support',
  },
  descriptions: {
    basic:
      'Get started with our free plan, ideal for small projects and individuals. Enjoy essential features and analytics without any cost.',
    pro:
      'Upgrade to the Pro plan for enhanced capabilities. Access unlimited campaigns, A/B Testing, and priority support. Perfect for growing businesses.',
    agency:
      'Choose the Agency Yearly plan for comprehensive support and advanced features. Benefit from priority support, extensive visitor capacity, and the ability to manage multiple domains.',
  },
  tagline: {
    basic:
      '',
    pro:
      'Most popular',
    agency:
      'Greatest value',
  },
}

export default plans
